<template>
  <div class="area-chart-wrap">
    <ECharts 
      v-if="approvalAreaList.length" 
      :options="options" 
      autoresize 
      class="chart"
    />
    <div v-else class="non-data">暂无数据</div>
  </div>
</template>

<script>
import utils from "@/utils/index";

import ECharts from 'vue-echarts'
import "echarts/lib/chart/pie";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";
import "echarts/lib/component/legendScroll.js";
import "echarts/lib/component/title.js";
import "echarts/lib/component/toolbox.js";


export default {
  components: {
    ECharts
  },
  data() {
    return {
      approvalAreaList: [],
      legendData: [],
    };
  },
  computed: {
    approvalTotal() {
      return this.approvalAreaList.reduce(this.getNum, 0);
    },
    options() {
      return {
        title: {
          text: utils.getThousandsNum(this.approvalTotal),
          top: "middle",
          left: "34%",
          textAlign: "center",
        },
        legend: {
          type: 'scroll',
          orient: 'vertical',
          right: 0,
          top: 50,
          icon: 'circle',
          itemHeight: 6,
          itemWidth: 6,
          data: this.approvalAreaList.map(el => el.name),
          formatter: function (name) {
            if (name.length > 20) return name.slice(0, 20) + '...'
            return name
          },
          textStyle: {
            padding: [0, 0, 0, 12]
          }
        },
        color: [
          '#5B8FF9', '#CDDDFD', '#61DDAA', '#CDF3E4', '#65789B', 
          '#CED4DE', '#F6BD16', '#FCEBB9', '#7262fd', '#D3CEFD',
          '#78D3F8', '#D3EEF9', '#9661BC', '#DECFEA', '#F6903D',
          '#FFE0C7', '#008685', '#BBDEDE', '#F08BB4', '#FFE0ED'   
        ],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        toolbox: {
          show: true,
          right: 0,
          feature: {
            mark: {show: true},
            dataView: {show: true, readOnly: true},
            saveAsImage: {show: true}
          }
        },
        series: {
          name: "审批单总量",
          type: "pie",
          radius: ["50%", "70%"],
          center: ["34%", "50%"],
          data: this.approvalAreaList
        },
      };
    },
  },
  created() {
    this.getPersonalApprovalArea();
  },
  methods: {
    getPersonalApprovalArea() {
      _api.dataCenter.personalApprovalArea().then((data) => {
        this.approvalAreaList = (data || []).map(el => {
          return {...el, value: el.num}
        });
      });
    },
    getNum(total, el) {
      return total + Number(el.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.area-chart-wrap {
  .chart {
    width: 100%;
  }
  .non-data {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 400px;
  }
}
</style>
